import type { ClientErrorReportInput } from '@/lib/ops/client-error-report.schema'

const INTAKE_PATH = '/api/ops/error-report'

export function reportClientCrash(
  error: Error,
  extras: Omit<ClientErrorReportInput, 'name' | 'message' | 'stack'> = {},
): void {
  if (typeof window === 'undefined') return

  const body: ClientErrorReportInput = {
    name: error.name,
    message: error.message || 'Unknown client error',
    stack: error.stack,
    route: extras.route ?? window.location.pathname,
    digest: extras.digest,
    componentStack: extras.componentStack,
    source: extras.source,
  }

  void fetch(INTAKE_PATH, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => undefined)
}
